<template>
  <section class="flex flex-col items-center md:mt-16 mb-8">
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" width="300" height="300">
      <path
        d="M152.9 37c-7.3-1.4-14.2 2.9-15.4 9.5-.4 2.3-.1 4.7.9 6.8l-3.2 5.1 6-1.2a14 14 0 0 0 7.1 3.7c7.3 1.4 14.1-2.9 15.4-9.5 1.3-6.6-3.6-13-10.8-14.4Z"
        fill="#FDA4AF"
      />
      <path
        d="M62 81a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4ZM73 90.2a1.2 1.2 0 1 1-2.5 0 1.2 1.2 0 0 1 2.4 0ZM84.2 81.5a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0ZM96.5 91.7a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0ZM107 81.5a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0ZM120.2 82.1a1.2 1.2 0 0 1-.8 1.2 1.2 1.2 0 1 1 .8-1.2ZM133.5 81.5a1.2 1.2 0 1 0 0-2.5 1.2 1.2 0 0 0 0 2.5ZM128.3 93.2a1.2 1.2 0 0 1-.8 1.1 1.2 1.2 0 1 1 .8-1Z"
        fill="#F43F5E"
      />
      <path
        d="m99.3 68.3-1.4 2v-1.7l1.4-.3ZM136.2 74.2l.4-.3 4-1.4c-2.5-1.2-4.7-.6-4.4 1.7ZM144 79.6l-2.4.9c1.7.7 3.4.6 3.8-.8l-1.3-.1ZM91.2 184.5c-.2-2.2-.7-4.3-1.4-6.3-3.9 1.1-8 1.1-11.9 0-5.1 1.5-11 6.1-14.1 9l25-.1a2.3 2.3 0 0 0 2.3-1.7c.1-.3.2-.6.1-1ZM149 168.9l-3.4-1.8c-1.3 4.4-3 5.7-7 8.4 2 3.2 1.5 4.7 1.3 5.6-2.2 2.1-3.3 2.1-4.9 6h7.7a5.4 5.4 0 0 0 5-3c1.1-2.4 2.1-7.5 3.2-10.5a3.8 3.8 0 0 0-1.9-4.7ZM151.4 53.2a.6.6 0 1 1-1.3 0 .6.6 0 0 1 1.3 0Z"
        fill="#E4E4E7"
      />
      <path
        d="M117.2 55.4a2.5 2.5 0 0 0-.6-5 2.5 2.5 0 0 0-2.3-4.2 2.5 2.5 0 0 0-2.2-3.6c-.5 0-1 .1-1.5.5a2.5 2.5 0 0 0-4.7-1.6 2.6 2.6 0 0 0-5.1 0A2.5 2.5 0 0 0 96 43a2.5 2.5 0 0 0-3.8 3.1 2.5 2.5 0 0 0-2.3 4.3 2.5 2.5 0 0 0-.7 4.9 2.5 2.5 0 0 0 .6 4.9 2.5 2.5 0 0 0 2.4 4.3 2.5 2.5 0 0 0 2.4 3.5c-1-.9-1.5-2.9.3-7 3.3-7.6 6.3-2.4 6.2.7 0 .5.4.7 1.2 0 1.7-1.4 3.2 1.5 0 3.3-.7.3-1 1-.6 5l.2.9a2.5 2.5 0 0 0 3.7-1.8 2.5 2.5 0 0 0 4.7-1.5 2.5 2.5 0 0 0 3.7-3 2.5 2.5 0 0 0 2.4-4.3 2.5 2.5 0 0 0 .7-5Z"
        fill="#18181B"
      />
      <path d="M151.4 53.2a.6.6 0 1 1-1.3 0 .6.6 0 0 1 1.3 0Z" stroke="#18181B" stroke-width="1.5" />
      <path
        d="M143.4 82a45.7 45.7 0 0 1-19.2 58.1M62.6 76.5a45.7 45.7 0 0 1 25-19.6m49.8 15a45.7 45.7 0 0 0-18.5-13.8M84 142.6A45.7 45.7 0 0 1 57.7 87M109.3 145.5a47.4 47.4 0 0 1-11.4.5"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M145 80.3c-3.5 3.6-8.3 8.7-13.1 14.6a7.5 7.5 0 0 1-10.3 1.3l-11.9-8.8M97.9 70.3l1.4-2"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M136.6 72.5c-4 3.5-7.6 7.4-10.8 11.7 0 0-9-7.6-15.3-11.4-6.4-3.9-8 2.6-8.7-2.8-.5-4 0-4.8.6-5.1 3.2-1.7 1.7-4.7 0-3.3-1 .9-1.1.5-1.2-.3-.1-3-3-7.7-6.1-.4-4.5 10.1 4.2 7.3 4.2 7.3"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M98 68.5c0 1.6-.2 4.1-1.8 3.7-4-.9-5.7-.3-8 1.5-4.4 3.5-13.5 8.7-13.5 8.7-5.5-3.3-9.4-4.7-14.4-6.9a17 17 0 0 0-4.4 10.8c7.2 3 10 4.8 15.6 7.6a8.4 8.4 0 0 0 8-.4 200 200 0 0 1 10.5-6M140.6 72.5c-2.2-1-4.2-.8-4.4.9-.2 1.4.7 3.1 1.7 4.2a9 9 0 0 0 5.1 3.2 2 2 0 0 0 2.4-1.2"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M88.9 79.8c.4 6 2 12 4.5 17.4 5.6 1.5 10.1 1.1 15.7-.6a27 27 0 0 1 1.7-12.4M141.6 80.4a30.7 30.7 0 0 1 15.3-2.8c3.6.3 4.2-.5.4-1.8a121.8 121.8 0 0 0-19-2.4"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M136.2 74.2s8.4-3.2 11.8-4.7c3.9-1.8 2.8-.4 1.8.8-.7.8-4.3 3.2-2.4 3.8M144 79.6c2.3-.6 6.6-.1 8.6 0 1.5 0 3.8.6 5.6.8.4 0 .8-.6-1.5-1.5l-3.2-1.3"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M144 79.6c1.8 0 3.6.2 5.4.6 1.4.3 3.8 1.2 5.4 1.6.4.1.9-.4-1.2-1.7l-.9-.5M56 84.6a32.7 32.7 0 0 0-16.1.9c-3.5 1-4.2.4-.9-1.7 5.6-2.7 11.4-5 17.4-6.8.8-.2 1.7-.2 2.6 0"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M48.3 79.8c1.8-1-2.4-2.5-3.3-3.2-1.2-.9-2.6-2 1.6-1.2 3.5.7 7.1 1.2 10.7 1.5M43.1 84.7l-2.7 1.9c-2 1.5-1.5 2-1 1.8 1.4-.5 3.8-1.6 5.2-2 2.2-.8 6.6-2.3 8.7-2"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="m44.4 86.4-.7.7c-1.7 1.8-1 2.1-.7 2l4.8-3c1.6-.7 3.3-1.3 5-1.8M91.2 184.4c-.2-2-.7-4.2-1.4-6.2-3.9 1.1-8 1.1-11.9 0-5.1 1.5-11 6-14.1 9l25-.2a2.3 2.3 0 0 0 1.8-.7 2.3 2.3 0 0 0 .6-1.9ZM96 149.7c.2 5-3.9 15.1-6.2 28.5M78 178.2l5.8-30.6M103.9 127.1l-7.2 22.4c-4.7.9-9.6 0-13.7-2.4l10.4-49.9M149 168.9l-3.3-1.8c-1.4 4.4-3 5.7-7.2 8.4 2.1 3.2 1.6 4.7 1.4 5.6-2.2 2.1-3.3 2-4.9 6h7.7a5.4 5.4 0 0 0 5-3c1.1-2.5 2.1-7.5 3.2-10.5a3.8 3.8 0 0 0-1.8-4.7ZM138.5 175.5l-22-23.7M126.1 144.3c3.1 2.6 5.9 5.5 8.3 8.6 3.4 4.6 11.3 14.2 11.3 14.2"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="m99.3 109.8 8.4 32c.7 2.5 2 4.7 3.8 6.4l4.2 4a20 20 0 0 0 10.7-8.4l-3.7-6.2-2.4-24.3c-1-9.1-6.3-15.3-11.2-16.7M105.8 71.5c-3 3.9-5.5 8.2-7.2 12.8-2.4-4-4.8-12.5-4.8-12.5M25.1 187.2h145.1M152.9 37c-7.3-1.4-14.2 2.8-15.4 9.4-.4 2.4-.1 4.7.9 6.9l-3.2 5 6-1.1c2 1.9 4.4 3.2 7.1 3.7 7.3 1.3 14.1-3 15.4-9.5 1.3-6.6-3.6-13-10.8-14.4Z"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M150.7 50.4c0-.8.4-1.4 1.4-2.8 2.2-2.9.9-4.9-1-5a2.3 2.3 0 0 0-2.4 2.6M142.8 138.8h4M153.8 138.8h3.9M150.3 131.4v3.9M150.3 142.3v4M145 133.6l2.8 2.7M152.8 141.3l2.7 2.7M155.5 133.5l-2.8 2.8M147.8 141.3 145 144M58.9 159v7.4M62.5 162.7h-7.3M102 70.8a2.5 2.5 0 0 0 3.7-1.8 2.5 2.5 0 0 0 4.7-1.4 2.5 2.5 0 0 0 3.7-3 2.5 2.5 0 0 0 2.4-4.3 2.5 2.5 0 0 0 2-4c-.4-.5-.8-.8-1.3-1A2.5 2.5 0 0 0 119 53a2.5 2.5 0 0 0-2.4-2.4 2.5 2.5 0 0 0-2.3-4.3 2.5 2.5 0 0 0-3.7-3.2 2.5 2.5 0 0 0-4.7-1.5c-.4-2.8-4.7-2.9-5.1 0A2.5 2.5 0 0 0 96 43a2.5 2.5 0 0 0-3.8 3 2.5 2.5 0 0 0-2.3 4.3 2.5 2.5 0 0 0-.7 5 2.5 2.5 0 0 0 .6 4.9 2.5 2.5 0 0 0 2.4 4.2 2.5 2.5 0 0 0 2.5 3.6M122.5 148.3l-4.7-5.6M91.5 149.6l2-7M105.8 103c2.7 3.1 5.6 4.5 8.7 4.4"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m42.5 14 23.3 40.3a4 4 0 0 1-3.4 6H15.8a4 4 0 0 1-3.5-6L35.6 14a4 4 0 0 1 7 0Zm-3.4 36a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        fill="#FDA4AF"
      />
      <path
        d="M15.8 60.3a4 4 0 0 1-3.5-6L35.6 14a4 4 0 0 1 7 0l23.2 40.3a4 4 0 0 1-3.4 6H15.8ZM72.2 37a2.1 2.1 0 1 1-4.3.4 2.1 2.1 0 0 1 4.3-.4Z"
        stroke="#18181B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M39 50a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" stroke="#18181B" stroke-width="1.5" />
      <path d="M39 27.5v14.3" stroke="#18181B" stroke-width="1.5" stroke-linecap="round" />
    </svg>
    <p class="mt-8 text-center">{{ $t('youAreOfflineText') }}</p>
  </section>
</template>

<script setup lang="ts">
import { useOnline, whenever } from '@vueuse/core';

const router = useRouter();
const isOnline = useOnline();

whenever(isOnline, () => router.push('/'), { immediate: true });
</script>
